import { DialogComponent } from '@theme/dialog';

/**
 * Blog Filter Drawer Component
 * Opens/closes a left-side drawer for blog filters.
 *
 * @extends {DialogComponent}
 */
class BlogFilterDrawerComponent extends DialogComponent {
    open() {
        this.showDialog();
    }

    close() {
        this.closeDialog();
    }
}

if (!customElements.get('blog-filter-drawer-component')) {
    customElements.define('blog-filter-drawer-component', BlogFilterDrawerComponent);
}


